"use client";
import { IProducts } from "@/api/AppApi/services/home/interfaces/IProduct";
import ProductEmblaSlider from "./ProductEmblaSlider";
import ProductBox from "../product-box/ProductBox";
import { ITheme } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useState } from "react";
import { useInViewEffect } from "react-hook-inview";
import { getProductBoxDefaultDimAndSpacing } from "../common/functions";
interface Props {
  products: IProducts;
  setIslastProduct?: (isLastProduct: boolean) => void;
  scrollableTabs?: boolean;
  theme: ITheme;
  showCustomEventData?: boolean;
  id?: string | number;
}
const ProductCarousel: React.FC<Props> = ({
  products,
  setIslastProduct,
  scrollableTabs,
  theme,
  showCustomEventData,
  id,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useInViewEffect(
    ([entry]) => {
      if (entry.isIntersecting) setIsVisible(true);
    },
    { threshold: 0, rootMargin: "200px" },
  );
  const size = products.configurations?.style_type!;
  const { height } = getProductBoxDefaultDimAndSpacing(size);
  const skipGate = typeof id === "string" && id.includes("_0_");
  const ready = skipGate || isVisible;
  return (
    <div
      ref={ref}
      style={{ contentVisibility: "auto", containIntrinsicSize: `${height}px` }}
    >
      {ready ? (
        <ProductEmblaSlider
          products={products}
          setIslastProduct={setIslastProduct}
          id={id}
        >
          {products?.data.map((single) => (
            <ProductBox
              isGrid={false}
              theme={theme}
              key={single.id}
              size={products.configurations?.style_type!}
              {...single}
              scrollableTabs={scrollableTabs!}
              priority={false}
              Customize={products?.configurations?.customize}
              showCustomEventData={showCustomEventData}
            />
          ))}
        </ProductEmblaSlider>
      ) : (
        <div
          className="skeleton-rect"
          style={{ width: "100%", paddingTop: `${Math.max(height, 100)}px` }}
        />
      )}
    </div>
  );
};

export default ProductCarousel;
